import https from "@/lib/https";
import type {
  CategoryDetail,
  CategoryPayload,
  GetCategoryListParams,
} from "@/interface/masterManagement";
import type { ApiResponse, PaginationResponse } from "@/interface/common";

const BASE_URL = "/api/master/skill-categories/";

export const getCategoryList = async (
  params: GetCategoryListParams,
): Promise<ApiResponse<PaginationResponse<CategoryDetail>>> => {
  return await https.get<ApiResponse<PaginationResponse<CategoryDetail>>>(
    BASE_URL,
    params,
  );
};

export const createCategory = async (
  payload: CategoryPayload,
): Promise<ApiResponse<CategoryDetail>> => {
  return await https.post<ApiResponse<CategoryDetail>>(BASE_URL, payload);
};

export const updateCategory = async (
  id: number | string,
  payload: CategoryPayload,
): Promise<ApiResponse<CategoryDetail>> => {
  return await https.put<ApiResponse<CategoryDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteCategory = async (
  id: number | string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}/`);
};
